import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useAppState } from '@/store/context';
import { WDAYS_MON, WDAYS_SUN } from '@/constants';
import { getCalCells, toStr, todayStr } from '@/utils';
import CalCell from '@/modules/calendar/cal-cell';
import style from './style.module.scss';
function MonthGrid({ budget, year, month, selectedDate, balances, dispatch, onAddTx }) {
    const { state } = useAppState();
    const showNext = state.profile.showNextMonth ?? true;
    const cells = useMemo(() => getCalCells(year, month, budget.weekStart, showNext), [year, month, budget.weekStart, showNext]);
    const wdays = budget.weekStart === 1 ? WDAYS_MON : WDAYS_SUN;
    const today = todayStr();
    return (_jsxs("div", { className: style['calendar-wrapper'], children: [_jsx("div", { className: style['calendar-day-headers'], children: wdays.map((d) => (_jsx("div", { className: style['cal-day-hdr'], children: d }, d))) }), _jsx("div", { className: style['calendar-grid'], "data-tut": "calendar-grid", children: cells.map((date) => {
                    const ds = toStr(date);
                    const muted = date.getMonth() !== month;
                    const txs = budget.transactions.filter((tx) => tx.date === ds);
                    return (_jsx(CalCell, { date: date, transactions: txs, budget: budget, balance: balances[ds], currency: budget.currency, isToday: !muted && ds === today, isSelected: !muted && ds === selectedDate, muted: muted, onSelect: () => {
                            if (muted) {
                                dispatch({ type: 'GO_MONTH', year: date.getFullYear(), month: date.getMonth() });
                            }
                            else {
                                dispatch({ type: 'SELECT_DATE', date: ds });
                            }
                        }, onAddTx: () => {
                            dispatch({ type: 'SELECT_DATE', date: ds });
                            onAddTx(ds);
                        } }, ds));
                }) })] }));
}
export default MonthGrid;
